import { useState } from "react";
import Button from "../common/Button";
import "./Table.scss";

export default function InputTooltip(props: {
    comment?: string,
    onSubmit: Function,
    onClose: Function,
}) {

    const [inputText, setInputText] = useState(props.comment || '');

    const {
        comment = '',
        onSubmit,
        onClose
    } = props;

    function handleSubmit(e: any) {
        e.preventDefault();
        onSubmit(inputText);
    }

    return (
        <>
            <div className="input_tooltip_wrapper">
                <div className="input_tooltip" onClick={(e) => e.stopPropagation()}>
                    <div
                        onClick={() => onClose()}
                        className="close-icon no-select"
                    >
                        ×
                    </div>

                    <form className="input_form" onSubmit={handleSubmit}>

                        <label className="sentence_form_label-optional">
                            <span>Commentary:</span>
                            <textarea
                                autoFocus
                                readOnly={false}
                                maxLength={256}
                                onChange={e => setInputText(e.target.value)}

                                value={inputText || ''}
                                name="input form comment"
                                placeholder=""
                            />
                        </label>

                        <Button text="&#x270E;" classes="green comment-button" onClick={handleSubmit} />
                    </form>

                </div>

            </div>
        </>
    );
}
